export default "__VITE_ASSET__25bd93dd__"